/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import simpleprg95grpexample_IconURL from '../RAISE_Logo.png';
import simpleprg95grpexample_InsetIconURL from '../PRG_Logo.png';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Simple Typescript Extension"
        description="name for the Simple Typescript Extension extension"
        id="extension.simpleprg95grpexample.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="Skeleton for a typescript extension"
        description="description for the Simple Typescript Extension extension"
        id="extension.simpleprg95grpexample.description"
    />
  ),
	implementationLanguage: 
  (
    <FormattedMessage
        defaultMessage="en"
        description="implementationLanguage for the Simple Typescript Extension extension"
        id="extension.simpleprg95grpexample.implementationLanguage"
    />
  ),
	es: {"name":"Extensión simple Typescript","description":"Ejemplo de una extensión simple usando Typescript"},
	blockColor: 
  (
    <FormattedMessage
        defaultMessage="#822fbd"
        description="blockColor for the Simple Typescript Extension extension"
        id="extension.simpleprg95grpexample.blockColor"
    />
  ),
	menuColor: 
  (
    <FormattedMessage
        defaultMessage="#4ed422"
        description="menuColor for the Simple Typescript Extension extension"
        id="extension.simpleprg95grpexample.menuColor"
    />
  ),
	menuSelectColor: 
  (
    <FormattedMessage
        defaultMessage="#9e0d2c"
        description="menuSelectColor for the Simple Typescript Extension extension"
        id="extension.simpleprg95grpexample.menuSelectColor"
    />
  ),
	tags: ["PRG Internal"],
	featured: true,
	extensionId: 'simpleprg95grpexample',
	iconURL: simpleprg95grpexample_IconURL,
	insetIconURL: simpleprg95grpexample_InsetIconURL,
}